import api from './BaseApi';

export const getAlertRules = async (params = {}) => {
    try {
        const queryParams = typeof params === 'number' ? { limit: params } : params;
        const response = await api.get('/flights/alerts/rules', { params: queryParams });
        return response.data;
    } catch (error) {
        console.error('Error fetching alert rules:', error);
        throw error;
    }
};

export const createAlertRule = async (data) => {
    try {
        const response = await api.post('/flights/alerts/rules', data);
        return response.data;
    } catch (error) {
        console.error('Error creating alert rule:', error);
        throw error;
    }
};

export const deleteAlertRule = async (id) => {
    try {
        const response = await api.delete(`/flights/alerts/rules/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting alert rule:', error);
        throw error;
    }
};

export const getTop100Airports = async () => {
    try {
        const response = await api.get('/flights/alerts/top100');
        return response.data;
    } catch (error) {
        console.error('Error fetching top 100 airports:', error);
        throw error;
    }
};

export const syncAirportAlerts = async (payload) => {
    try {
        const response = await api.post('/flights/alerts/sync-airport', payload);
        return response.data;
    } catch (error) {
        console.error('Error syncing airport alerts:', error);
        throw error;
    }
};

export const getAlertLogs = async () => {
    try {
        const response = await api.get('/flights/alerts/logs');
        return response.data;
    } catch (error) {
        console.error('Error fetching alert logs:', error);
        throw error;
    }
};

export const clearAlertLogs = async () => {
    try {
        const response = await api.delete('/flights/alerts/logs');
        return response.data;
    } catch (error) {
        console.error('Error clearing alert logs:', error);
        throw error;
    }
};

export const getFlightChangeHistory = async (limit = 50) => {
    try {
        const response = await api.get('/flights/alerts/history', { params: { limit } });
        return response.data;
    } catch (error) {
        console.error('Error fetching flight change history:', error);
        throw error;
    }
};

export const getAirportSyncLogs = async (params = {}) => {
    try {
        const response = await api.get('/flights/alerts/sync-logs', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching airport sync logs:', error);
        throw error;
    }
};

export const startBulkFlightSync = async (payload = {}) => {
    try {
        const response = await api.post('/flights/alerts/bulk-sync', payload);
        return response.data;
    } catch (error) {
        console.error('Error starting bulk sync:', error);
        throw error;
    }
};

export const getBulkFlightSyncStatus = async () => {
    try {
        const response = await api.get('/flights/alerts/bulk-sync-status');
        return response.data;
    } catch (error) {
        console.error('Error getting bulk sync status:', error);
        throw error;
    }
};

export const stopBulkFlightSync = async () => {
    try {
        const response = await api.post('/flights/alerts/bulk-sync-stop');
        return response.data;
    } catch (error) {
        console.error('Error stopping bulk sync:', error);
        throw error;
    }
};

export const syncAviationstackAirport = async (payload) => {
    try {
        const response = await api.post('/flights/aviationstack/sync-airport', payload);
        return response.data;
    } catch (error) {
        console.error('Error syncing airport from Aviationstack:', error);
        throw error;
    }
};

export const getAviationstackUsage = async () => {
    try {
        const response = await api.get('/flights/aviationstack/usage');
        return response.data;
    } catch (error) {
        console.error('Error fetching Aviationstack usage:', error);
        throw error;
    }
};
